import React from "react";
import { bottomDrawerHelperActions } from "src/components/20-helper-views/bottom-drawer/useBottomDrawer";
import ChangesSentForReviewDrawer from "../ChangesSentForReviewDrawer";
import ChangesUpdateSuccessDrawer from "../ChangesUpdateSuccessDrawer";
export function useHandleMutationCompleted() {
    return (data) => {
        if (data.sentForReview) {
            bottomDrawerHelperActions.show({
                id: 'ep_sent_for_review',
                component: (React.createElement(ChangesSentForReviewDrawer, { onConfirm: bottomDrawerHelperActions.hide })),
                duration: 10000,
            });
        }
        else {
            bottomDrawerHelperActions.show({
                id: 'ep_update_success',
                component: (React.createElement(ChangesUpdateSuccessDrawer, { onConfirm: bottomDrawerHelperActions.hide })),
                duration: 7000,
            });
        }
    };
}
